// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"23":"549ce072","57":"dff0ed7b","246":"61edba8a","624":"61edba8a","831":"ab88de26","838":"b601049f","860":"61edba8a","870":"dff0ed7b","921":"a469d692"}[chunkId] + ".chunk.css";
};